const RugGuaranteesStatus = Object.freeze({
    PROPIA: 10,
    AJENA: 20
})

module.exports = RugGuaranteesStatus
